/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';
import { getAsync, postAsync } from '../../../components/helper/axiosHelper';
import { getStorage } from '../../../libs/getStorage';
import { PageHitCountApi } from '../../../shared/Helper';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import CertificateModal from '../../../components/elements/CertificateModal';
import Userbanner from '../../../components/elements/Userbanner';
import PaymentsCards from './PaymentsCards';

const GiftPayment = () => {
  const navigate = useNavigate();
  const [dynamicInput, setDynamicInput] = useState([]);
  const [checkbox, setCheckbox] = useState();
  const [isModal, setIsModal] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [epUserID, setEpUserID] = useState(null);
  const [mobileNum, setMobileNum] = useState({ beneMobile: '', senderMobile: '' });
  const [CreateEPGift, setCreateEPGift] = useState({
    senderName: '' || apiData?.fullName,
    senderMobile: '',
    serviceGiftID: 0,
    amount: '',
    beneficiaryModelList: [
      {
        beneName: '',
        beneMobile: '',
        giftServiceBeneID: 0,
        giftServiceID: 0,
      },
    ],
  });
  const token = localStorage.getItem('token');
  const inputBeneRef = useRef();
  const numInputBeneref = useRef();

  let axiosConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const getUserData = async () => {
    await getAsync('EP_UserAuthentication/EPUserByID/', { id: epUserID }, axiosConfig)
      .then((response) => {
        const result = response?.data[0];
        setApiData(result);

        if (result) {
          setValue('senderName', result?.fullName);
          setValue('senderMobile', result?.mobile);
        }
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });

    if (!token) {
      PageHitCountApi(location.pathname, 0);
    }

    if (token) {
      if (epUserID !== null) {
        getUserData();
        PageHitCountApi(location.pathname, epUserID);
      }
      localStorage.setItem('isHome', false);
    } else {
      localStorage.setItem('isHome', true);
    }
  }, [epUserID]);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    initial: CreateEPGift,
  });

  const [dataObj, setDataObj] = useState({
    giftTypeID: 0,
    projectID: '',
    projectName: '',
  });

  const dataObject = {
    paymentMethodId: 1,
    amount: CreateEPGift.amount,
    required: true,
    projectName: dataObj.projectName,
  };

  const onPaymentCard = async (formData) => {
    setCreateEPGift((prevState) => {
      const newState = { ...prevState };
      newState.giftTypeID = formData.giftTypeID;
      newState.projectID = formData.projectID;
      return newState;
    });
  };
  // const finalInput = dynamicInput.filter((input) => input.beneMobile  !== null && input.beneName !== null && input.beneMobile  !== '' && input.beneName !== '')

  const prices = [{ price: 10 }, { price: 50 }, { price: 100 }];

  // const createTask = () => {

  //   setDynamicInput([
  //     ...dynamicInput,
  //     {
  //       beneName: CreateEPGift.beneficiaryModelList.beneName,
  //       beneMobile: CreateEPGift.beneficiaryModelList.beneMobile,
  //       giftServiceBeneID: 0,
  //       giftServiceID: 0,
  //     },
  //   ]);
  // };
  const createTask = () => {
    const newTask = {
      beneName: CreateEPGift.beneficiaryModelList.beneName,
      beneMobile: CreateEPGift.beneficiaryModelList.beneMobile,
      giftServiceBeneID: 0,
      giftServiceID: 0,
    };

    if (newTask.beneName && newTask.beneMobile) {
      setDynamicInput([...dynamicInput, newTask]);

      // Reset the input fields to empty strings
      // setCreateEPGift((prevState) => {
      //   const newState = { ...prevState };
      //   newState.beneficiaryModelList.beneMobile = "";
      //   return newState;

      // });

      CreateEPGift.beneName = '';
      setCreateEPGift((prevState) => ({
        ...prevState,
        beneficiaryModelList: prevState.beneficiaryModelList.map((beneficiary, index) => ({
          ...beneficiary,
          beneName: '',
          beneMobile: '',
        })),
      }));
      inputBeneRef.current.value = '';
      numInputBeneref.current.value = '';
    } else {
      console.log('Task not added due to empty or null fields.');
    }
  };

  const deleteTask = (index) => {
    const list = [...dynamicInput];
    list.splice(index, 1);
    setDynamicInput(list);
  };

  const formatPrice = (value) => {
    const numericValue = parseFloat(value);
    if (!isNaN(numericValue)) {
      return numericValue.toFixed(2);
    } else {
      return ''; // or handle the error as needed
    }
  };

  // Create Link Api for User
  const createLinkApi = async (giftLogLink) => {
    const link = `/externalPayment/${dataObj?.projectID}/${giftLogLink}/7/${dataObj.projectTypeIdInt}`;
    navigate(link, { state: { paymentInfo: dataObject } });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (/^\+?\d*$/.test(value)) {
      setMobileNum((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const onSubmit = async (formData) => {
    // prevent default
    try {
      const data = {
        giftTypeID: Number(dataObj.giftTypeID),
        projectID: dataObj.projectID,
        showAmountID: 1,
        serviceGiftID: 0,
        certDesignID: 1,
        ProjectTypeIdInt: dataObj.projectTypeIdInt,
        epUserID: Number(getStorage('id')) || 1,
        amount: formatPrice(CreateEPGift.amount) || 0,
        senderMobile: mobileNum.senderMobile ?? apiData?.mobile,
        senderName: formData.senderName ?? apiData?.fullName,
        beneficiaryModelList: [
          ...dynamicInput,
          {
            beneName: formData.beneName,
            beneMobile: mobileNum?.beneMobile,
            giftServiceBeneID: 0,
            giftServiceID: 0,
          },
        ],
      };
      if (dataObj.projectID !== '') {
        const response = await postAsync('GiftService/CreateEPServiceGift', data);
        if (response) {
          createLinkApi(response.value.giftLogLink);

          if (response?.value.serviceGiftID > 0) {
            reset();
          }
        }
      } else {
        toast.error(t('Please select project first'));
      }
    } catch (error) {
      console.log(error);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const showCertificate = watch('cert', false);

  return (
    <>
      <div className={`pt-12 lg:pt-12 ${!token ? 'xl:pt-32' : ''}  ${isModal} ? "overflow-y-hidden" : ""`}>
        {token && <Userbanner />}
        <div className="card-header shadow-md flex justify-center py-3 ">
          <h2 className="text-3xl text-customgreen text-center  w-full  font-bold">{t('Jude Gifts')}</h2>
        </div>
        <PaymentsCards onPaymentCard={onPaymentCard} setDataObj={setDataObj} dataObj={dataObj} />
        {/* <input type="checkbox" {...register('showAge')} /> */}
        <div className="w-full pb-5  mx-auto px-4 rounded shadow-md">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className=" flex justify-center pb-12 ">
              <h2 className="text-xl text-black text-center  w-full  font-bold">{t('Beneficiary Detail')}</h2>
            </div>
            <div className="flex flex-col md:flex-row -mx-3 mb-2">
              <div className=" mb-3 w-full px-3 md:mb-0 ">
                <label className="mb-2 block text-xs font-bold uppercase tracking-wid" htmlFor="beneName">
                  {t('Name Of Beneficiary')}
                </label>
                <input
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block w-full p-2.5"
                  id="beneName"
                  type="text"
                  placeholder={t('Enter Name Of Beneficiary')}
                  {...register('beneName', { required: true })}
                />
                {errors.beneName && <span className="text-red-500">{t('This field is required')}</span>}
              </div>

              <div className=" mb-3  w-full px-3 md:mb-0">
                <label className="mb-2 block text-xs font-bold uppercase tracking-wid" htmlFor="beneMobile">
                  {t('Mobile Number Of Beneficiary')}
                </label>

                <input
                  value={mobileNum?.beneMobile}
                  onChange={handleInputChange}
                  placeholder={t('Enter Mobile Number Of Beneficiary')}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block w-full p-2.5"
                  type="text"
                  name="beneMobile"
                  min="0"
                />
                <p className="mt-2 text-sm">{t('Your mobile number should starts with +971.')}</p>
              </div>
            </div>

            <hr className="py-4" />

            <div className="flex items-end mb-4 ">
              <div className="flex justify-start gap-3 items-center flex-row flex-wrap  ">
                {prices.map((item, index) => (
                  <div key={index} className="cursor-pointer w-24 px-2">
                    <div
                      //name="amount"
                      value={item.price}
                      // {...register('amount', { required: true })}
                      onClick={() =>
                        setCreateEPGift((prevState) => {
                          const newState = { ...prevState };
                          newState.amount = item.price;
                          return newState;
                        })
                      }
                      className="text-white w-full bg-gradient-to-r from-customgreen via-customgreen to-customgreen bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-customgreen dark:focus:ring-customgreen font-medium rounded-lg text-sm  py-2.5 text-center"
                    >
                      {item.price}
                    </div>
                  </div>
                ))}
                {/* <input
                  className="bg-gray-50 border border-gray-300 focus:ring-customgreen focus:border-customgreen  rounded-md"
                  maxLength="6"
                  type="text"
                  name="amount"
                  value={CreateEPGift.amount}
                  placeholder="0"
                  {...register('amount', {
                    required: true,
                    validate: (value) =>
                      /^(\d+(\.\d{0,2})?)?$/.test(value) || 'Invalid decimal number (up to 2 decimal places)',
                  })}
                  onInput={(event) => {
                    const { value } = event.target;
                    const regex = /^(0|[1-9]\d*)(\.\d{1,2})?$/;

                    if (regex.test(value) || value === '') {
                      setCreateEPGift((prevState) => ({
                        ...prevState,
                        amount: value,
                      }));
                      setValue('amount', value, { shouldValidate: true });
                    } else {
                      event.target.value = CreateEPGift.amount;
                    }
                  }}
                  onChange={(event) =>
                    setCreateEPGift((prevState) => ({
                      ...prevState,
                      amount: event.target.value,
                    }))
                  }
                /> */}
                <input
                  className="bg-gray-50 border border-gray-300 focus:ring-customgreen focus:border-customgreen rounded-md"
                  maxLength="6"
                  type="text"
                  name="amount"
                  value={CreateEPGift.amount}
                  placeholder={t('Enter Amount')}
                  {...register('amount', {
                    required: true,
                    validate: (value) => {
                      if (value === '0' || value === '0.0' || value === '0.00') {
                        return 'Amount cannot be zero';
                      }
                      return /^(\d+(\.\d{0,2})?)?$/.test(value) || 'Invalid decimal number (up to 2 decimal places)';
                    },
                  })}
                  onInput={(event) => {
                    let { value } = event.target;
                    const regex = /^(0|[1-9]\d*)(\.\d{1,2})?$/;

                    // Ensure value is not zero
                    if (value === '0' || value === '0.0' || value === '0.00') {
                      event.target.value = '';
                      setCreateEPGift((prevState) => ({
                        ...prevState,
                        amount: '',
                      }));
                      setValue('amount', '', { shouldValidate: true });
                      return;
                    }

                    if (regex.test(value) || value === '') {
                      setCreateEPGift((prevState) => ({
                        ...prevState,
                        amount: value,
                      }));
                      setValue('amount', value, { shouldValidate: true });
                    } else {
                      event.target.value = CreateEPGift.amount;
                    }
                  }}
                  onChange={(event) =>
                    setCreateEPGift((prevState) => ({
                      ...prevState,
                      amount: event.target.value,
                    }))
                  }
                />
              </div>
            </div>

            {/* {errors.amount && <span className="text-red-500">{t('This field is required')}</span>} */}

            <div className=" mb-2">
              <div className="w-full flex flex-col  px-3 md:mb-0 ">
                <div className=" w-full mb-2 md:mb-0  flex items-center">
                  <input
                    type="checkbox"
                    id="cert"
                    name="cert"
                    {...register('cert')}
                    className=" h-8 w-8 sm:h-6 sm:w-6 text-customgreen focus:ring-customgreen"
                  />
                  <label
                    className="mb-2 m-2  md:mx-3 text-xs font-bold uppercase tracking-wide text-gray-700"
                    htmlFor="grid-zip"
                  >
                    {t('Amount Included In Certificate')}
                  </label>
                </div>
                <div>
                  <button
                    type="button"
                    className="border-3 bg-customgreen text-white border-customgreen rounded-full flex flex-row-reverse items-center gap-2 text-xs text-center self-center px-3 py-2 my-2 mx-2"
                    onClick={() => setCheckbox((prev) => !prev)} // Toggle the checkbox state
                  >
                    <i className="fab fa-plus"></i>
                    {t('Add More Beneficiary')}
                  </button>
                </div>
                {/* <div className=" w-full mb-2 md:mb-0 ">
                  <input
                    type="checkbox"
                    id="showCertificate"
                    { ...register('showCertificate', {}) }
                    className=" h-8 w-8 sm:h-6 sm:w-6 text-customgreen focus:ring-customgreen"
                    onChange={ (e) => {
                      setCheckbox(e.target.checked);
                    } }
                  />
                  <label className="mb-2 mx-2 md:mx-3  text-xs font-bold uppercase tracking-wide text-gray-700">
                    { t('Add More Beneficiary') }
                  </label>
                </div> */}
              </div>
            </div>

            {checkbox && (
              <>
                <div className="grid md:grid-cols-6  -mx-3 mb-2">
                  <div className="grid-cols-subgrid md:col-span-3  mb-2 w-full px-3 md:mb-0 ">
                    <input
                      placeholder={t('Enter Name Of Beneficiary')}
                      ref={inputBeneRef}
                      name="beneName"
                      // value={ CreateEPGift.beneName }
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block w-full p-2.5"
                      type="text"
                      onChange={(event) =>
                        setCreateEPGift((prevState) => {
                          const newState = { ...prevState };
                          newState.beneficiaryModelList.beneName = event.target.value;
                          return newState;
                        })
                      }
                    />
                  </div>
                  <div className="w-full grid-cols-subgrid md:col-span-3 px-3 mb-2 md:mb-0">
                    <input
                      placeholder={t('Enter Mobile Number Of Beneficiary')}
                      name="beneMobile"
                      ref={numInputBeneref}
                      // value={ CreateEPGift.beneMobile }
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block w-full p-2.5"
                      type="text"
                      onInput={(event) => {
                        const { value } = event.target;
                        if (/^\+?\d*$/.test(value)) {
                          setCreateEPGift((prevState) => {
                            const newState = { ...prevState };
                            newState.beneficiaryModelList.beneMobile = value;
                            return newState;
                          });
                        } else {
                          event.target.value = '';
                          setCreateEPGift((prevState) => {
                            const newState = { ...prevState };
                            newState.beneficiaryModelList.beneMobile = '';
                            return newState;
                          });
                        }
                      }}
                    />
                    {/* <p className="mt-2 text-sm">{t('Your number should start with 971.')}</p> */}
                    <p className="mt-2 text-sm">{t('Mobile number should starts with +971.')}</p>

                    {/* add item  */}
                    <div className="w-full px-3 my-7 grid-cols-subgrid md:col-span-3 md:mb-0">
                      <button
                        type="button"
                        onClick={createTask}
                        className="text-customgreen border border-customgreen hover:bg-hovergreen hover:text-white focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-lg text-sm p-2.5 text-center inline-flex items-center me-2 dark:border-customgreen dark:text-customgreen dark:hover:text-white dark:focus:ring-customgreen dark:hover:bg-hovergreen"
                      >
                        <svg
                          className="w-5 h-5 transition-transform group-hover:rotate-45"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 18 18"
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 1v16M1 9h16"
                          ></path>
                        </svg>

                        <span className="sr-only">Icon description</span>
                      </button>
                    </div>
                  </div>
                </div>
                {dynamicInput.length > 0 && (
                  <div className="overflow-x-auto w-full">
                    <table className="min-w-full text-left">
                      <thead className="text-gray-200 uppercase bg-customgreen">
                        <tr>
                          <td className="py-1 border text-center w-24 font-bold p-4">{t('sNo')}</td>
                          <td className="py-1 border text-center font-bold p-4">{t('Name')}</td>
                          <td className="py-1 border text-center font-bold p-4">{t('Mobile')}</td>
                          <td className="py-1 border text-center font-bold p-4">{t('Delete')}</td>
                        </tr>
                      </thead>
                      {dynamicInput.map((item, index) => (
                        <tbody className="text-gray-700" key={index}>
                          <tr>
                            <td className="py-1 border text-center p-4">{index + 1}</td>
                            <td className="py-1 border text-center p-4">{item.beneName}</td>
                            <td className="py-1 border text-center p-4">{item.beneMobile}</td>
                            <td className="py-1 border text-center p-4">
                              <button
                                className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center"
                                type="button"
                                onClick={() => deleteTask(index)}
                              >
                                {t('Delete')}
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      ))}
                    </table>
                  </div>
                )}
              </>
            )}
            <hr className="py-4 " />
            {/* <PriceSelector /> */}
            {/* <div className=" flex justify-center pb-12 ">
              <h2 className="text-xl text-black text-center  w-full  font-bold">{ t('Amount Detail') }</h2>
            </div> */}

            <div className=" flex justify-center pb-12 ">
              <h2 className="text-xl text-black text-center  w-full  font-bold">{t('Sender Detail')}</h2>
            </div>
            {/* Sender */}
            <div className=" grid md:grid-cols-6  -mx-3 mb-2">
              <div className="grid-cols-subgrid md:col-span-3  mb-2 w-full px-3 md:mb-0 ">
                <label className="my-2 block text-xs font-bold uppercase tracking-wid" htmlFor="grid-first-name">
                  {t('Name Of Sender')}
                </label>
                <input
                  disabled={apiData?.fullName && apiData?.mobile}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block w-full p-2.5"
                  id="senderName"
                  type="text"
                  placeholder={t('Enter Name Of Sender')}
                  {...register('senderName')}
                />
              </div>
              <div className="w-full px-3 mb-2 grid-cols-subgrid md:col-span-3 md:mb-0">
                <label
                  className="block my-2 uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="senderMobile"
                >
                  {t('Sender Mobile')}
                </label>
                <input
                  disabled={apiData?.fullName && apiData?.mobile}
                  value={apiData?.mobile ? apiData?.mobile : mobileNum?.senderMobile}
                  onChange={handleInputChange}
                  placeholder={t('Enter Sender Mobile')}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block w-full p-2.5"
                  type="text"
                  name="senderMobile"
                  min="0"
                />
                <p className="mt-2 text-sm">{t('Your mobile number should starts with +971.')}</p>
              </div>
            </div>
            <div className=" flex flex-row-reverse item-center justify-between flex-wrap-reverse items-center gap-4">
              {/* <div className=" "> */}
              {/* <input
                  type="submit"
                  className="focus:outline-none w-full sm:w-auto text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-3 py-2 me-2 "
                  value={ t(`Payment`) }
                /> */}
              <button
                type="submit"
                className="w-full sxx:w-auto focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-3 py-2 me-2  dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                // onClick={ () => setIsModal(true) }
              >
                {t('Payment')}
              </button>
              {/* </div> */}

              {dataObj.giftTypeID !== null && dataObj.giftTypeID !== 0 ? (
                <button
                  onClick={() => {
                    const link = `/certificateTemplate`;
                    navigate(link, { state: { id: dataObj?.giftTypeID } });
                  }}
                  className="w-full sxx:w-auto focus:outline-none text-white bg-customgreen hover:bg-hovergreen  focus:ring-customgreen font-medium rounded-full text-sm px-3 py-2 me-2  dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                >
                  {t('Show Certificate')}
                </button>
              ) : (
                <span
                  onClick={() => {
                    toast.error(t('Select Gift Type'));
                  }}
                  className="w-full flex justify-center cursor-pointer sxx:w-auto focus:outline-none text-white bg-customgreen hover:bg-hovergreen  focus:ring-customgreen font-medium rounded-full text-sm px-3 py-2 me-2  dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                >
                  {t('Show Certificate')}
                </span> // Or any other fallback element
              )}

              {/* <Link
                className="w-full sxx:w-auto focus:outline-none text-white bg-customgreen hover:bg-hovergreen  focus:ring-customgreen font-medium rounded-full text-sm px-3 py-2 me-2  dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                to={
                  dataObj.giftTypeID !== null && dataObj.giftTypeID !== 0
                    && `/certificateView/${dataObj.giftTypeID}`
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('Show Certificate')}
              </Link> */}
              {/* <button
                className="w-full sxx:w-auto focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-3 py-2 me-2  dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                onClick={ () => setIsModal(true) }
              >
                { t('Show Certificate') }
              </button> */}
            </div>
          </form>
          <CertificateModal watch={watch} showCertificate={showCertificate} amount={CreateEPGift.amount} />
        </div>

        {/* <CertificateModal watch={watch} showCertificate={showCertificate} amount={CreateEPGift.amount} /> */}
      </div>

      {/* <CertificateTemplate data={ CreateEPGift } isModal={ isModal } setIsModal={ setIsModal } /> */}
    </>
  );
};

export default GiftPayment;
